/**
 * Country-specific registration labels and public registry links for admin licence verification.
 */

export const WORKFLOW_HELP =
  "The practitioner provides their licence. You verify the number with the country's official registry, then approve public listing. Two separate steps.";

const REGISTRATION_LABELS = {
  FR: "Registration number (RPPS)",
  GB: "Registration number (GMC)",
  UK: "Registration number (GMC)",
  ES: "Registration number (Colegiado)",
  US: "Registration number (NPI)",
  TR: "Registration number (Diploma No)",
  BE: "Registration number (INAMI)",
  ML: "Registration number",
};

const REGISTRIES = {
  FR: {
    label: "Search RPPS — Annuaire Santé",
    url: "https://annuaire.sante.fr/",
  },
  GB: {
    label: "Search GMC register",
    url: "https://www.gmc-uk.org/registration-and-licensing/the-medical-register",
  },
  UK: {
    label: "Search GMC register",
    url: "https://www.gmc-uk.org/registration-and-licensing/the-medical-register",
  },
  ES: {
    label: "Search Colegio de Médicos",
    url: "https://www.cgcom.es/",
  },
  US: {
    label: "Search NPI registry",
    url: "https://npiregistry.cms.hhs.gov/",
  },
};

export const CHECKLIST_LABELS = {
  credentialsVerified: "Licence verified by an agent",
  licensePresent: "Registration number provided",
  practiceCountry: "Country of practice set",
  accountNotBanned: "Account active",
  clinicApproved: "Clinic approved for public listing",
};

export function normalizeCountry(raw) {
  const c = String(raw || "")
    .trim()
    .toUpperCase();
  if (c === "UK") return "GB";
  return c.length === 2 ? c : "";
}

export function registrationNumberLabel(country) {
  const iso = normalizeCountry(country);
  return REGISTRATION_LABELS[iso] || "Registration number";
}

export function registryForCountry(country) {
  const iso = normalizeCountry(country);
  return REGISTRIES[iso] || null;
}

export function checklistLabel(id) {
  return CHECKLIST_LABELS[id] || null;
}

export function formatVerifierLine(name, at) {
  if (!at) return "";
  const when = formatDate(at);
  if (name && when) return `Verified by ${name} on ${when}`;
  if (when) return `Verified on ${when}`;
  return "";
}

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return "";
  }
}
